// PostgreSQL stores microseconds; Date.parse alone collapses distinct positions.
function submillisecond(value) {
  return Number((/\.(\d+)(?:Z|[+-]\d\d:\d\d)$/.exec(value)?.[1] || '').padEnd(6, '0').slice(3, 6));
}

export function compareMessages(left, right) {
  return Date.parse(left.occurred_at) - Date.parse(right.occurred_at)
    || submillisecond(left.occurred_at) - submillisecond(right.occurred_at)
    || left.sequence - right.sequence;
}

export function requireHistoryContract(options) {
  const contract = options.history_contract;
  if (contract?.version !== 2 || contract.order !== 'chronological' || contract.read !== 'message_ids') {
    throw Object.assign(new Error('Unsupported inbox timeline'), { code: 'inbox_client_update_required' });
  }
}
